import React from 'react';

import { ReceiptPreviewModal } from './ReceiptPreviewModal';
import type { ReceiptData } from '../../utils/receipt';

interface ReceiptRendererProps {
  data: ReceiptData | null;
  onComplete?: (mode?: 'print' | 'pdf' | 'preview') => void;
}

/**
 * Instead of auto-printing, we now show a preview modal so the cashier
 * can review the ticket and choose to print or download PDF.
 */
export function ReceiptRenderer({ data, onComplete }: ReceiptRendererProps) {
  const handleClose = () => {
    onComplete?.('preview');
  };

  return (
    <ReceiptPreviewModal
      data={data}
      onClose={handleClose}
    />
  );
}

export default ReceiptRenderer;
